<project-navigation
  [headerTitle]="'projectNavigation.csv_export_title'"
  [headerText]="'projectNavigation.csv_export_message'"
  [model]="model"
  [submitEnabled]="submitEnabled"
  [actionButtonLabel]="'global.label.next'"
  [selectionAvailable]="true"
  [visibleFeatures]="{
    compositeCheckBox: false,
    pinnedProjects: true,
    recentlyUsedProjects: true,
    history: true,
    projectActionsMenu: true,
    projectGroupContextMenu: true,
    newConfigurationGroupBtn: false,
    newFolderBtn: false,
    dialogSearch: true,
    tabs: true,
    breadcrumbs: true,
  }"
  (submitEnabledChanged)="updateSubmitEnabled()"
  (actionBtnClick)="saveSelectedCsv()"
  (cancel)="cancel()"
></project-navigation>
